import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import { IH2HMatchesData } from "core-integration/src/store/leagues/types";
import ButtonLink from "plos/src/components/links/ButtonLink";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NextIcon, PrevIcon } from "../../../icons/Chevrons";
import { nextButton, pager } from "../../shared/styles/leaguesTableStyles.css";
import { MatchItem } from "./MatchItem";

interface MatchesTableProps {
  selectedEntry: number;
  isCup?: boolean;
  isAllMine?: boolean;
  matches: IH2HMatchesData;
  pageMatches: number;
  toPrevious: string;
  toNext: string;
}

const MatchesList = ({
  selectedEntry,
  isAllMine = false,
  isCup = false,
  matches,
  pageMatches,
  toPrevious,
  toNext,
}: MatchesTableProps) => {
  const { t } = useTranslation("leaguesAndCups");
  const now = useSelector(getCurrentEvent);

  if (matches.results.length === 0) {
    return null;
  }

  return (
    <>
      <ul>
        {matches.results.map((m) => (
          <MatchItem
            selectedEntry={selectedEntry}
            key={m.id}
            match={m}
            started={now ? m.event <= now.id : false}
            showEvent
            isAllMine={isAllMine}
            isCup={isCup}
          />
        ))}
      </ul>
      {/*  TODO update to new Pager Buttons */}
      <div className={pager}>
        {pageMatches > 1 && (
          <ButtonLink to={toPrevious} appearance="tonal" size="small">
            <PrevIcon />
            <span>{t("pagination.previous", "Previous")}</span>
          </ButtonLink>
        )}
        {matches.has_next && (
          <ButtonLink
            to={toNext}
            appearance="tonal"
            size="small"
            className={nextButton}
          >
            <span>{t("pagination.next", "Next")}</span>
            <NextIcon />
          </ButtonLink>
        )}
      </div>
    </>
  );
};

export default MatchesList;
